// extracted by mini-css-extract-plugin
export default {"root":"BackdropDropdown_root__SdLeb","item":"BackdropDropdown_item__VUmyc","bottom":"BackdropDropdown_bottom__nSZv-","body":"BackdropDropdown_body__i0wy6"};